import { object, ObjectSchema, string } from "yup";
import "yup-phone-lite";
import { UsernameType } from "../types";

export interface LoginFormData {
  username: string;
  password?: string;
}

export const defaultValues: LoginFormData = {
  username: "",
  password: "",
};

export const createValidationSchema = (
  usernameType: UsernameType
): ObjectSchema<LoginFormData | Pick<LoginFormData, "username">> =>
  object({
    username:
      usernameType === "email"
        ? string().email("Email is invalid").required("Email is required")
        : string()
            .phone("US", "Please enter a valid phone number")
            .required("Phone number is required"),
    password:
      usernameType === "email"
        ? string().required("Password is required")
        : string().nullable(),
  });
